import { graphql } from '@/gql/codegen/gql';

import { GET_COURSE_LESSON } from '@/routes/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/index.route.lazy';
import { useMutation } from '@apollo/client';
import { useCallback, useState } from 'react';

export const ANSWER_SELF_SUMMARIZING_QUESTION_MUTAITON = graphql(/* GraphQL */ `
  mutation EmbaAnswerSelfSummarizingQuestion(
    $input: AnswerSelfSummarizingQuestionMutationInput!
  ) {
    embaAnswerSelfSummarizingQuestion(input: $input) {
      success
    }
  }
`);

export const useAnswerSelfSummarizingQuestionMutation = (
  embaUserAttendanceSlug: string,
  embaCourseLessonSlug: string,
) => {
  const [isAnsweredModalOpen, setIsAnsweredModalOpen] = useState(false);

  const [
    embaAnswerSelfSummarizingQuestionMutation,
    {
      error: answerSelfSummarizingQuestionError,
      loading: answerSelfSummarizingQuestionLoading,
    },
  ] = useMutation(ANSWER_SELF_SUMMARIZING_QUESTION_MUTAITON, {
    refetchQueries: [
      {
        query: GET_COURSE_LESSON,
        variables: {
          embaUserAttendanceSlug,
          embaCourseLessonSlug,
        },
      },
    ],
  });

  const answerSelfSummarizingQuestion = useCallback(
    async (
      content: string,
      embaSelfSummarizingQuestionId: number,
    ): Promise<void> => {
      await embaAnswerSelfSummarizingQuestionMutation({
        variables: {
          input: {
            embaUserAttendanceSlug,
            content,
            embaCourseLessonSlug,
            embaSelfSummarizingQuestionId:
              embaSelfSummarizingQuestionId.toString(),
          },
        },
      });
      setIsAnsweredModalOpen(true);
    },
    [
      embaAnswerSelfSummarizingQuestionMutation,
      embaUserAttendanceSlug,
      embaCourseLessonSlug,
    ],
  );

  const closeAnsweredModal = useCallback(() => {
    setIsAnsweredModalOpen(false);
  }, []);

  return {
    answerSelfSummarizingQuestion,
    answerSelfSummarizingQuestionError,
    answerSelfSummarizingQuestionLoading,
    isAnsweredModalOpen,
    closeAnsweredModal,
  };
};
